import { produce } from 'immer';
import type { StoreApi } from 'zustand';
import type { MapWithImage } from '@/lib/db-row-types';

// Maps slice - uses MapWithImage to support header_image_url from AI images
export type MapsState = {
  maps: Record<string, MapWithImage>;
  mapsLoading: boolean;
  setMaps: (maps: MapWithImage[]) => void;
  setMapsLoading: (loading: boolean) => void;
  clearMaps: () => void;
  setMap: (map: MapWithImage) => void;
  removeMap: (id: string) => void;
};

export const createMapsSlice = (set: StoreApi<any>['setState']) => ({
  maps: {},
  mapsLoading: false,
  setMaps: (maps: MapWithImage[]) =>
    set(
      produce((draft: MapsState) => {
        draft.maps = Object.fromEntries(maps.map(m => [m.id, m]));
        draft.mapsLoading = false;
      })
    ),
  setMapsLoading: (loading: boolean) =>
    set(
      produce((draft: MapsState) => {
        draft.mapsLoading = loading;
      })
    ),
  clearMaps: () =>
    set(
      produce((draft: MapsState) => {
        draft.maps = {};
        draft.mapsLoading = false;
      })
    ),
  setMap: (map: MapWithImage) =>
    set(
      produce((draft: MapsState) => {
        draft.maps[map.id] = map;
      })
    ),
  removeMap: (id: string) =>
    set(
      produce((draft: MapsState) => {
        delete draft.maps[id];
      })
    ),
});
